/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raffle_Results_HeaderInputs */



/**
* | output |
* | --- |
* | "Past draws" |
*
* @param {Raffle_Results_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_results_header = /** @type {((inputs?: Raffle_Results_HeaderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_Results_HeaderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tirages précédents")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sorteos anteriores")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sorteios anteriores")
	if (locale === "it") return /** @type {LocalizedString} */ ("Estrazioni precedenti")
	return /** @type {LocalizedString} */ ("Past draws")
});